import { useTranslation } from "react-i18next";
import { Text } from "@foris/avocado-suite";
import cx from "classnames";
import DropdownBox from "@common/components/dropdown-box";
import type { UnassignedSessionsProps } from "./types";
import { getUnassignedSessionsSummary } from "./unassignedSessions.utils";
import styles from "./unassignedSessions.module.scss";

const UnassignedSessions = ({ sessions, selectedWeekId, onSelect }: UnassignedSessionsProps) => {
  const { t } = useTranslation();
  const { rows, totalBlocks } = getUnassignedSessionsSummary(sessions, selectedWeekId);

  if (!rows.length) return null;

  const formatBlocks = (count: number | null) =>
    count === null ? "–" : t("dimension.common.unscheduled-blocks", { count });

  return (
    <DropdownBox
      className={styles.unassignedSessions}
      title={t(
        rows.length === 1
          ? "dimension.common.show-unassigned-sessions-one"
          : "dimension.common.show-unassigned-sessions",
        { count: rows.length },
      )}
      headerExtra={<Text type="lg">{formatBlocks(totalBlocks)}</Text>}
    >
      <div className={styles.unassignedSessions_list}>
        {rows.map(row => {
          const { session } = row;
          const component =
            session.resource?.info?.courseComponent?.component?.code ??
            session.resource?.info?.section?.component?.code ??
            "";

          return (
            <div
              className={cx(styles.unassignedSessions_row, "container-row")}
              key={`${session.sectionId}-${session.sessionId}`}
              role="button"
              tabIndex={0}
              onClick={() => onSelect(row)}
              onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelect(row);
                }
              }}
            >
              <Text className={cx(styles.unassignedSessions_text, "col_2")}>
                {session.sessionId}
              </Text>
              <Text
                className={cx(
                  styles.unassignedSessions_text,
                  styles.unassignedSessions_text__name,
                  "col_6",
                )}
              >
                {session.name}
              </Text>
              <Text className={cx(styles.unassignedSessions_text, "col_2")}>{component}</Text>
              <Text className={cx(styles.unassignedSessions_count, "col_2")}>
                {formatBlocks(row.totalBlocks)}
              </Text>
            </div>
          );
        })}
      </div>
    </DropdownBox>
  );
};

export default UnassignedSessions;
